import { render, staticRenderFns } from "./ButtonComponent.vue?vue&type=template&id=d70549ec"
import script from "./ButtonComponent.vue?vue&type=script&lang=ts"
export * from "./ButtonComponent.vue?vue&type=script&lang=ts"
import style0 from "./ButtonComponent.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/app/components/base/Icon/Icon.vue').default})
